module.exports = __webpack_public_path__ + "static/media/linkedin.7fb8b02f.webp";